export const LEVELS = ['easy', 'medium', 'hard', 'extra-hard', 'experts-only'] as const;
export type Level = (typeof LEVELS)[number];

export const LEVEL_INFO: Record<Level, { name: string; blurb: string }> = {
  easy: { name: 'Easy', blurb: 'Singles only, plenty of clues. Relaxed.' },
  medium: { name: 'Medium', blurb: 'Adds pointing. Scanning boxes pays off.' },
  hard: { name: 'Hard', blurb: 'Adds pairs. Notes start to help.' },
  'extra-hard': { name: 'Extra Hard', blurb: 'Triples, X-Wing, Y-Wing. Real thinking.' },
  'experts-only': { name: 'Experts Only', blurb: 'Swordfish, coloring, chains. Slow and deep.' },
};

/** A puzzle as the API sends it: no solution. */
export interface PublicPuzzle {
  id: string;
  level: Level;
  /** 81 digits, 0 = empty. */
  givens: string;
  clues: number;
}

export interface CellDigit {
  cell: number;
  digit: number;
}

/** A hint step from the API. */
export interface HintStep {
  kind: 'step';
  technique: string;
  techniqueName: string;
  tier: number;
  nudge: string;
  message: string;
  focusCells: number[];
  /** Identifies the step; the game remembers which keys it has shown. */
  key: string;
  /** Shown before in this game, so not counted again. */
  repeat: boolean;
  /** "Another hint" ran out of new steps and is going round earlier ones. */
  cycling: boolean;
  reveal: {
    cells: number[];
    digits: number[];
    placements: CellDigit[];
    eliminations: CellDigit[];
  };
}

export type HintResponse =
  | HintStep
  | { kind: 'solved' }
  | { kind: 'mistakes'; count: number }
  | { kind: 'none' };

export interface CheckResponse {
  wrongCells: number[];
  solved: boolean;
}
